import { Directive } from '@angular/core';
import { DepotTransferFacade } from '@zero/self-service/domain';

@Directive()
export class DepotTransferPageBase {
  constructor(public depotTransferFacade: DepotTransferFacade) {}

  public async init() {
    await this.depotTransferFacade.setup();
  }
}
